import { registerBlockType } from '@wordpress/blocks';
import Edit from './edit';
import metadata from './block.json';

const stockItem = (
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M20.5547 8.90625C20.6849 9.21875 20.75 9.55729 20.75 9.92188V18.75C20.724 19.4531 20.4766 20.0391 20.0078 20.5078C19.5391 20.9766 18.9531 21.224 18.25 21.25H5.75C5.04688 21.224 4.46094 20.9766 3.99219 20.5078C3.52344 20.0391 3.27604 19.4531 3.25 18.75V9.92188C3.25 9.55729 3.32812 9.21875 3.48438 8.90625L5.08594 5.23438C5.55469 4.29688 6.32292 3.80208 7.39062 3.75H16.6094C17.6771 3.80208 18.4453 4.29688 18.9141 5.23438L20.5547 8.90625ZM14.5 8.75H18.4062L17.1953 6.01562C17.0911 5.75521 16.8958 5.625 16.6094 5.625H13.4453L14.5 8.75ZM10.5547 5.625H7.39062C7.10417 5.625 6.90885 5.75521 6.80469 6.01562L5.59375 8.75H9.46094L10.5547 5.625ZM9.5 10.625H5.125V18.75C5.15104 19.1406 5.35938 19.349 5.75 19.375H18.25C18.6406 19.349 18.849 19.1406 18.875 18.75V10.625H14.5V12.5C14.5 12.8646 14.3828 13.1641 14.1484 13.3984C13.9141 13.6328 13.6146 13.75 13.25 13.75H10.75C10.3854 13.75 10.0859 13.6328 9.85156 13.3984C9.61719 13.1641 9.5 12.8646 9.5 12.5V10.625Z"
            fill="#7351FD"
        />
    </svg>
);

registerBlockType(metadata.name, {
    icon: stockItem,
    title: metadata.title,
    edit: Edit,
});
